import { createToken } from '../../api/api';

import { IPaymentLinkFormValues } from '../schema';
import { ISubmitPaymentLinkPayload } from '../types/types';
import { PAYMENT_METHODS } from './paymentMethods';

export const buildPaymentPayload = async (
  values: IPaymentLinkFormValues,
  planId: string,
): Promise<ISubmitPaymentLinkPayload> => {
  const paymentMethod = values.paymentMethodSelected;

  const payload: ISubmitPaymentLinkPayload = {
    payment_method: PAYMENT_METHODS[paymentMethod],
    planId,
    card: null,
  }

  if (paymentMethod !== 'credit_card') return payload;

  const token = await createToken({
    card_number: values.cardNumber,
    cardholder_name: values.cardHolderName,
    card_expiration: values.cardExpiration,
    card_cvv: values.cardCvv,
  });
  return {
    ...payload,
    card: {
      token: token.id,
      last_digits: values.cardNumber.replace(/\s/g, '').slice(-4),
      expiration_date: values.cardExpiration,
      holder_name: values.cardHolderName,
      brand: token.card?.brand || '',
    },
  };
};

